module.exports = __webpack_public_path__ + "img/580975ffcbe96274aa76b44fbf5ba934.svg";